import { NAME } from './constants';

export const FETCH_CREDENTIALS = `${NAME}/FETCH_CREDENTIALS`;
export const FETCH_CREDENTIALS_FAILURE = `${NAME}/FETCH_CREDENTIALS_FAILURE`;
export const FETCH_CREDENTIALS_SUCCESS = `${NAME}/FETCH_CREDENTIALS_SUCCESS`;

export const FETCH_PROVIDERS = `${NAME}/FETCH_PROVIDERS`;
export const FETCH_PROVIDERS_FAILURE = `${NAME}/FETCH_PROVIDERS_FAILURE`;
export const FETCH_PROVIDERS_SUCCESS = `${NAME}/FETCH_PROVIDERS_SUCCESS`;

export const RESET = `${NAME}/RESET`;
